import { createSelector, EntityState } from '@reduxjs/toolkit';
import { unwrap } from '@ff-os/shared-utils/unwrap';
import { wrap } from '@ff-os/shared-utils/wrap';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { isEqual } from 'lodash';

let cachedUserInput: EntityState<GiftJson.Input<any>>;

// Ensures updates are only triggered from user input
export const selectInputsWithoutComputedProperties = createSelector([
    (state: GiftPdpState) => state.project.inputs,
    (state: GiftPdpState) => state.project.variables
], (
    inputs,
    variables
): EntityState<GiftJson.Input<any>> => {

    const userInput = withoutComputedProperties(inputs, variables);

    if (!isEqual(userInput, cachedUserInput)) {
        cachedUserInput = userInput;
    }

    return cachedUserInput;
});

const withoutComputedProperties = (
    inputs: EntityState<GiftJson.Input<any>>,
    variables: EntityState<GiftJson.Variable<any>>
) => {

    const results = [];

    for (const input of unwrap(inputs)) {
        if (variables.entities[input.id]?.pluginId === 'text') {
            const { computedFontSize, computedHeight, ...userInput } = input.value;
            results.push({ ...input, value: userInput });
        } else if (variables.entities[input.id]?.pluginId === 'photo') {
            const { assetUrl, status, ...userInput } = input.value;
            results.push({ ...input, value: userInput });
        } else {
            results.push(input);
        }
    }

    return wrap(results);
};